import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Instructions.css";
import { FaClock, FaBan, FaShare, FaExclamationCircle } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { InfinitySpin } from "react-loader-spinner";

const Instructions = () => {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    setLoading(true);
    if (token) {
      if (!accepted) {
        setLoading(false);
        return toast.error("Please accept the instructions.");
      }
      try {
        const response = await axios.post(
          `https://app.instaconnects.com/api/v1/exams/startExam/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          navigate(`/exam/${id}`);
          setLoading(false);
          toast.success("Exam Started Successfuly");
        } else {
          toast.error("Exam Start failed. Please try again.");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error exam Start:", error);
        toast.error("Exam Start failed. Please try again.");
        setLoading(false);
      }
    } else {
      toast.error("An error occurred. Please try again.");
      navigate("/");
      setLoading(false);
    }
  };

  return (
    <div className="instructions-container-main">
      <div className="instructions-container">
        <h2 className="instructions-title">Assessment's Instructions</h2>
        <div className="instructions-card">
          <ul className="instructions-list">
            <li className="instruction-item">
              <FaClock className="instruction-icon" />
              The exam is timed (30 minutes).
            </li>
            <li className="instruction-item">
              <FaBan className="instruction-icon" />
              Do not refresh or close the browser tab.
            </li>
            <li className="instruction-item">
              <FaShare className="instruction-icon" />
              All answers will be automatically submitted when time runs out.
            </li>
            <li className="instruction-item">
              <FaExclamationCircle className="instruction-icon" />
              Only one attempt is allowed per user.
            </li>
          </ul>

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={accepted}
              onChange={() => setAccepted(!accepted)}
              className="checkbox"
            />
            <span className="checkbox-text">
              I have read and understood the instructions.
            </span>
          </label>

          <div className="submit-button-container">
            {loading ? (
              <>
                <button className="submit-button-loading" disabled>
                  <InfinitySpin
                    visible={true}
                    width="80"
                    color="#fff"
                    ariaLabel="infinity-spin-loading"
                  />
                </button>
              </>
            ) : (
              <button
                className="start-button"
                onClick={handleStart}
                disabled={!accepted}
              >
                Start Exam
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
